import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ImportPage } from "@/features/import/ImportPage";
import { IMPORT_STEPS, IMPORT_TYPES, type ImportType } from "@/features/import/route-params";

const importSearch = z.object({
  step: z.enum(IMPORT_STEPS).optional(),
  state: z.enum(["loading", "empty", "error"]).optional(),
});

export const Route = createFileRoute("/_app/import/$type")({
  validateSearch: importSearch,
  component: Page,
});

function Page() {
  const { type } = Route.useParams();
  const search = Route.useSearch();
  const known: ImportType = (IMPORT_TYPES as readonly string[]).includes(type) ? (type as ImportType) : "clients";
  return <ImportPage type={known} search={search} />;
}
